import $api from '@/services/api';

export default {
  getAutocomplete({ commit }) {
    $api.get('/v1/dashboard/autocomplete').then((items) => {
      commit('setAutocomplete', items);
    });
  },

  getSubdistributorsList({ commit, state }, payload) {
    state.loading = true;
    return $api.get('/v1/dashboard/subdistributors', payload).then((subdistributors) => {
      commit('setSubdistributors', subdistributors);
      state.loading = false;
    }).catch(() => { state.loading = false; });
  },

  getChains({ commit, state }, payload = { distributor_id: null, subdistributor_id: null }) {
    state.loading = true;
    state.params = payload;
    return $api.get('/v1/dashboard/chains', payload).then((chains) => {
      commit('setChains', chains);
      state.loading = false;
    }).catch(() => { state.loading = false; });
  },

  getStores({ commit, state }, payload = { distributor_id: null, subdistributor_id: null, chain_id: null }) {
    state.loading = true;
    state.params = payload;
    return $api.get('/v1/dashboard/stores', payload).then((stores) => {
      commit('setStores', stores);
      state.loading = false;
    }).catch(() => { state.loading = false; });
  },

  getInstalls({ state }, payload) {
    state.loading = true;

    $api.get('/v1/dashboard/installs', payload).then((installs) => {
      state.installs = installs;
      state.loading = false;
    }).catch(() => { state.loading = false; });
  },

  getUsers({ state }, payload) {
    state.loading = true;

    $api.get('/v1/dashboard/accessgrants', payload).then((grants) => {
      state.grants = grants;
      state.loading = false;
    }).catch(() => { state.loading = false; });
  },
};
